import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom'
import Select from 'react-select'

const SelectRefinement = connectRefinementList(({
    refine,
    items,
    placeholder,
    currentRefinement
}) => {

    const dressLabel = (label) => {
        if(placeholder === "Access") {
            return label + " Performance";
        }
        return label;
    }

    const currentValue = () => {
        if (currentRefinement.length > 0) {
            const refinementString = currentRefinement.join('')
            return {
                value: refinementString,
                label: refinementString
            }
        }
        return null
    }

    const instanceId = placeholder.toLowerCase().replace(/\s+/g, '-');
    const labelId = `${instanceId}-label`;

    return (
        <Select 
            instanceId={instanceId}
            aria-labelledby={labelId}
            theme={(theme) => ({
                ...theme,
                borderRadius: 0,
                colors: {
                    ...theme.colors,
                    primary25: '#D3A3A1',
                    primary: '#E30614'
                },
            })}
            className='react-select-container' 
            isSearchable={false} 
            classNamePrefix='react-select' 
            value={currentValue()} 
            isClearable 
            backspaceRemovesValue
            escapeClearsValue
            getOptionLabel={option => dressLabel(option.label)}
            getOptionValue={option => option.label}
            isOptionSelected={(option) => option.isRefined}
            options={items}
            placeholder={placeholder} 
            onChange={(option, actionMeta) => {
                if (!option) {
                    refine('')
                } else if (actionMeta.action === 'select-option' && option.label === currentRefinement[0]) {
                    refine('')
                } else {
                    refine(option.label)
                }
            }}
        />
    )
})

export default SelectRefinement


// WEBPACK FOOTER //
// ./src/whatson/components/SelectRefinement.js